import { useReadCurrentUserVehiclesQuery } from "../state/api/vehicle.api";
import { SelectOption } from "../types/SelectOption";
import { Vehicle } from "../types/Vehicle";
import { LabelHelper } from "../util/labelHelper";

export const useVehicleList = (userId: number | undefined) => {
  const { data, isLoading } = useReadCurrentUserVehiclesQuery({UserId: Number(userId)});
  const vehicleList: SelectOption[] = data ? data.map((v: Vehicle) => {
    // check is this unique value, 
    // I think, reason for this logic is, same vehicle can be added by several users in the past........
    // let itemsWithSameRegNo = 0;
    // data.forEach((v2: Vehicle) => {
    //   if (v.regNo === v2.regNo) {
    //     itemsWithSameRegNo++;
    //   }
    // });

    // return {
    //   id: v.id,
    //   label: itemsWithSameRegNo === 1 ? `${LabelHelper.displayRegNo(v.regNo)}` : `${LabelHelper.displayRegNo(v.regNo)}(${v.id ?? 'NoId'})`,
    // };

    return {
      id: v.id,
      label: `${LabelHelper.displayRegNo(v.regNo)}`,
    };
  }): [];
  return {vehicleList, isLoading};
};
